import type { Vec3, View } from "eutopia.ts";

import type { Bounds } from "../model";

const earthCircumference = 40075016;

export const boundsToView = ([
  minLon,
  minLat,
  maxLon = minLon,
  maxLat = minLat,
]: Bounds) => {
  const center: Vec3 = [(minLon + maxLon) / 2, (minLat + maxLat) / 2, 0];
  const lat = ((minLat + maxLat) / 2) * (Math.PI / 180);
  const dx = ((maxLon - minLon) / 360) * earthCircumference * Math.cos(lat);
  const dy = ((maxLat - minLat) / 360) * earthCircumference;
  const distance = Math.max(10000, Math.sqrt(dx * dx + dy * dy));
  return {
    center,
    distance,
    orientation: [0, 0, 0],
    fieldOfView: 45,
  } satisfies View;
};
